export const IST_TIME_ZONE = "Asia/Kolkata";

export function formatDateTimeIST(value, fallback = "—", options = {}) {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  const { withSeconds = false, withZone = false } = options;
  const parts = new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIME_ZONE,
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: withSeconds ? "2-digit" : undefined,
    hour12: true
  }).formatToParts(date);

  const byType = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  const day = byType.day || "";
  const month = byType.month || "";
  const year = byType.year || "";
  const hour = byType.hour || "00";
  const minute = byType.minute || "00";
  const second = withSeconds ? `:${byType.second || "00"}` : "";
  const dayPeriod = (byType.dayPeriod || "").toUpperCase();
  const zone = withZone ? " IST" : "";

  return `${day} ${month} ${year}, ${hour}:${minute}${second} ${dayPeriod}${zone}`.trim();
}
